import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OnlineUsersState {
  users: string[];
  username: string;
}

const initialState: OnlineUsersState = {
  users: [],
  username: ""
};

export const onlineUsersSlice = createSlice({
  name: "onlineUsers",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<string>) => {
      if (state.username !== action.payload) state.users.push(action.payload);
    },
    remove: (state, action: PayloadAction<string>) => {
      if (state.username !== action.payload) {
        state.users = state.users.filter(u => u !== action.payload);
      }
    },
    set: (state, action: PayloadAction<string[]>) => {
      state.users = action.payload.filter(u => u !== state.username);
    },
    setUsername: (state, action: PayloadAction<{ username: string }>) => {
      const newUser = action.payload.username;
      const oldUser = state.username;

      state.username = newUser;
      state.users = state.users.filter(u => u !== oldUser && u !== newUser);
    },
    reset: () => initialState
  }
});

export const { append, remove, set, setUsername, reset } = onlineUsersSlice.actions;
export default onlineUsersSlice.reducer;
